import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Database, AlertTriangle } from "lucide-react";

export default function AdminOdooStatus() {
    const [status, setStatus] = useState(null);
    useEffect(() => { api.get("/odoo/status").then((r) => setStatus(r.data)); }, []);
    return (
        <div data-testid="admin-odoo">
            <h1 className="text-2xl font-semibold mb-1 flex items-center gap-2" style={{ fontFamily: "'Space Grotesk',sans-serif" }}>
                <Database className="w-6 h-6" /> Estado de Odoo
                <Badge className="bg-amber-100 text-amber-900 hover:bg-amber-100 border-amber-300">MOCK</Badge>
            </h1>
            <p className="text-muted-foreground mb-4">Integración simulada. Reemplazar con JSON-RPC real cuando los endpoints estén disponibles.</p>
            <Card className="p-6 border-amber-200 bg-amber-50/40 mb-4">
                <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-amber-700 mt-0.5" />
                    <div>
                        <div className="font-semibold text-amber-900">Integración MOCKED</div>
                        <p className="text-sm text-amber-900/80">Los datos de programación (RAD), insumos y facturación DTE son simulados localmente. La estructura JSON y la generación del QR DTE están implementadas y listas para conectar con la API real de Odoo cuando esté disponible.</p>
                    </div>
                </div>
            </Card>
            {status && (
                <Card className="p-4">
                    <h2 className="font-semibold mb-3">Diagnóstico</h2>
                    <dl className="grid sm:grid-cols-2 gap-3 text-sm">
                        <div><dt className="text-muted-foreground">Conexión</dt><dd className="font-medium">{status.connected ? "Conectado (Mock)" : "Desconectado"}</dd></div>
                        <div><dt className="text-muted-foreground">URL</dt><dd className="font-mono text-xs">{status.url}</dd></div>
                        <div><dt className="text-muted-foreground">Base de datos</dt><dd className="font-mono text-xs">{status.db}</dd></div>
                        <div><dt className="text-muted-foreground">Último sync</dt><dd className="font-mono text-xs">{status.last_sync}</dd></div>
                        <div><dt className="text-muted-foreground">Cola pendiente</dt><dd className="font-mono">{status.queued_operations}</dd></div>
                        <div><dt className="text-muted-foreground">Fallidas</dt><dd className="font-mono">{status.failed_operations}</dd></div>
                    </dl>
                </Card>
            )}
        </div>
    );
}
